import {
  MoneyFormat,
  MoneyFormatBackoffice,
  MoneyFormatBackofficeReport,
  MoneyFormatSideRates,
  MoneyFormatUpdated,
} from '@/models/MoneyFormat';
import {CurrencyCode} from '@/models/core/currency';

export function MoneyFormatFilter(amount: number|string, currency: CurrencyCode|string = CurrencyCode.USD): string {
  return MoneyFormat.format(amount, currency as CurrencyCode);
}

export function ChartTicksMoneyFormatFilter(amount: number|string, currency: CurrencyCode = CurrencyCode.USD): string {
  if (+amount >= 1000000000) {
    amount = Number(amount) / 1000000000;
    return MoneyFormat.format(amount, currency) + ' млрд.';
  }
  if (+amount >= 1000000) {
    amount = Number(amount) / 1000000;
    return MoneyFormat.format(amount, currency) + ' млн.';
  }
  if (+amount >= 1000) {
    amount = Number(amount) / 1000;
    return MoneyFormat.format(amount, currency) + ' тыс.';
  }
  return MoneyFormat.format(amount, currency);
}

export function RudeMoneyFormatFilter(amount: number|string, currency: CurrencyCode): string {
  if (+amount >= 1000000000) {
    amount = Number(amount) / 1000000000;
    return MoneyFormat.format(amount, currency) + ' млрд.';
  }
  if (+amount >= 1000000) {
    amount = Number(amount) / 1000000;
    return MoneyFormat.format(amount, currency) + ' млн.';
  }
  if (+amount >= 1000) {
    amount = Number(amount) / 1000;
    return MoneyFormat.format(amount, currency) + ' тыс.';
  }
  return MoneyFormat.format(amount, currency);
}


export function MoneyFormatFilterUpdated(amount: number|string, currency: CurrencyCode): string {
  return (new MoneyFormatUpdated()).format(amount, currency);
}

export function MoneyFormatFilterSideRates(amount: number|string, currency: CurrencyCode): string {
  return (new MoneyFormatSideRates()).formatToFloor(amount, currency);
}

export function MoneyFormatFilterBackoffice(amount: number|string, currency: CurrencyCode): string {
  return (new MoneyFormatBackoffice()).format(amount, currency);
}

export function MoneyFormatFilterBackofficeReport(amount: number|string, currency: CurrencyCode | string): string {
  return (new MoneyFormatBackofficeReport()).format(amount, currency);
}


